import {
  CertificateData,
  CertificateReferencesPayload,
  Certificates,
  Environments,
  ReplaceCertificate,
  RequestID
} from '../../types/resources/State';
import {
  GET_ALIASES_URL,
  GET_CERTIFICATES_URL,
  GET_CERTIFICATE_BY_ALIAS,
  GET_CERTIFICATE_DETAIL_URL,
  GET_REFERENCES_URL,
  GET_RESOURCE_REFERENCES_URL,
  REPLACE_CERTIFICATE_PRE_CHECK_URL
} from '../../constants/ApiUri';

import { Http } from 'vrlcm-gui-utils';
import { ResourceType } from '../../types/api-status';
import { ReferenceResponse } from 'vrlcm-gui-types';

export default class CertificateAPI {
  public static getCertificates = (payload?: {
    from: number;
    pageSize: number;
    filter: string;
  }): Promise<Certificates> => {
    const from = payload ? payload.from : 0;
    const pageSize = payload ? payload.pageSize : 10;
    const filter = payload ? encodeURIComponent(payload.filter) : '';
    return Http.get(GET_CERTIFICATES_URL(from, pageSize, filter)).then(
      res => res.data
    );
  };
  public static getCertificateDetail = (payload: {
    certificateVMID: string;
  }): Promise<CertificateData> => {
    const VMID = payload.certificateVMID;
    return Http.get(GET_CERTIFICATE_DETAIL_URL(VMID)).then(res => res.data);
  };
  public static getSelectedCertificateReferences = (
    certificateVMID: string
  ): Promise<Environments> => {
    const VMID = certificateVMID;
    return Http.get(GET_RESOURCE_REFERENCES_URL(VMID)).then(res => res.data);
  };

  public static getChooseCertificateReferences = (
    VMID: string
  ): Promise<ReferenceResponse> => {
    return Http.get(GET_REFERENCES_URL(VMID)).then(res => res.data);
  };

  public static getCertificateReferences = (
    payload: CertificateReferencesPayload
  ): Promise<Environments> => {
    const VMID = payload.certificateVMID;
    return Http.get(GET_RESOURCE_REFERENCES_URL(VMID)).then(res => res.data);
  };

  public static getAliases = (type: ResourceType): Promise<string[]> => {
    return Http.get(GET_ALIASES_URL(type)).then(res => res.data);
  };
  public static getCertificateByAlias = async (
    alias: string
  ): Promise<CertificateData> => {
    const response = await Http.get(GET_CERTIFICATE_BY_ALIAS(alias));
    return response.data;
  };
  public static replaceCertificatePreCheck = (
    payload: ReplaceCertificate
  ): Promise<RequestID> => {
    return Http.post(
      REPLACE_CERTIFICATE_PRE_CHECK_URL(payload.vmid),
      payload
    ).then(res => res.data);
  };
}
